import { createAppState } from '../appState';
import { runStalkerBanner } from '../../../shared/registrationTriggers/StalkerBanner/utils';
import { renderApp } from '../renderApp';
import { subscribeToInteractiveTime } from '../subscribeToInteractiveTime';

require('@cian/components/lib/index.css');
require('../../index.css');

export function runApp() {
  const store = createAppState();

  runStalkerBanner(store);
  subscribeToInteractiveTime({ store });
  renderApp(store);
}
